/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiTransactionRelatedPerson } from './InternalApiTransactionRelatedPerson';
import {
    InternalApiTransactionRelatedPersonFromJSON,
    InternalApiTransactionRelatedPersonFromJSONTyped,
    InternalApiTransactionRelatedPersonToJSON,
    InternalApiTransactionRelatedPersonToJSONTyped,
} from './InternalApiTransactionRelatedPerson';

/**
 * a Transaction
 * @export
 * @interface InternalApiTransaction
 */
export interface InternalApiTransaction {
    /**
     * External unique transaction ID
     * @type {string}
     * @memberof InternalApiTransaction
     */
    id: string;
    /**
     * Transaction attributes key value pair
     * @type {{ [key: string]: string; }}
     * @memberof InternalApiTransaction
     */
    attributes: { [key: string]: string; };
    /**
     * 
     * @type {Date}
     * @memberof InternalApiTransaction
     */
    createdTime: Date;
    /**
     * 
     * @type {string}
     * @memberof InternalApiTransaction
     */
    personId?: string;
    /**
     * 
     * @type {InternalApiTransactionRelatedPerson}
     * @memberof InternalApiTransaction
     */
    customer?: InternalApiTransactionRelatedPerson;
    /**
     * 
     * @type {Array<InternalApiTransactionRelatedPerson>}
     * @memberof InternalApiTransaction
     */
    relatedPersons: Array<InternalApiTransactionRelatedPerson>;
}

/**
 * Check if a given object implements the InternalApiTransaction interface.
 */
export function instanceOfInternalApiTransaction(value: object): value is InternalApiTransaction {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('attributes' in value) || value['attributes'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('relatedPersons' in value) || value['relatedPersons'] === undefined) return false;
    return true;
}

export function InternalApiTransactionFromJSON(json: any): InternalApiTransaction {
    return InternalApiTransactionFromJSONTyped(json, false);
}

export function InternalApiTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiTransaction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'attributes': json['attributes'],
        'createdTime': (new Date(json['createdTime'])),
        'personId': json['personId'] == null ? undefined : json['personId'],
        'customer': json['customer'] == null ? undefined : InternalApiTransactionRelatedPersonFromJSON(json['customer']),
        'relatedPersons': ((json['relatedPersons'] as Array<any>).map(InternalApiTransactionRelatedPersonFromJSON)),
    };
}

export function InternalApiTransactionToJSON(json: any): InternalApiTransaction {
    return InternalApiTransactionToJSONTyped(json, false);
}

export function InternalApiTransactionToJSONTyped(value?: InternalApiTransaction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'attributes': value['attributes'],
        'createdTime': value['createdTime'].toISOString(),
        'personId': value['personId'],
        'customer': InternalApiTransactionRelatedPersonToJSON(value['customer']),
        'relatedPersons': ((value['relatedPersons'] as Array<any>).map(InternalApiTransactionRelatedPersonToJSON)),
    };
}

